<!--
 * $Description: 业务操作-步骤
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年05月28日 14:15:56 +0800
 * @最后修改时间: 2022-03-22 13:24:54
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_Stepper.vue
-->
<template>
  <v-stepper v-model="curStep" class="elevation-0">
    <v-stepper-header
      :class="backgroundColor"
      style="height: auto"
      class="elevation-0"
    >
      <template v-for="(item, n) in items">
        <v-stepper-step
          :key="`${n + 1}-step`"
          :complete="curStep > n + 1"
          :step="n + 1"
          @click="$emit('step', n + 1)"
          class="pa-4"
          >{{ $t(item) }}</v-stepper-step
        >
        <!-- 2020-09-24 julia 要求改为默认样式-->
        <!-- :complete="curStep >= n + 1" -->
        <!-- :complete-icon="curStep == n + 1 ? 'edit' : 'check'" -->
        <v-divider
          class="ma-0"
          v-if="n !== items.length - 1"
          :key="`${n + 1}-line`"
        ></v-divider>
      </template>
    </v-stepper-header>
    <v-stepper-items class="pt-1" :class="backgroundColor">
      <v-stepper-content
        v-for="(item, n) in items"
        :key="`${n + 1}-content`"
        :step="n + 1"
        class="rounded-t elevation-0"
        :class="contentClass"
      >
        <slot :name="`content-${n + 1}`"></slot>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "Stepper",
  computed: {
    ...mapGetters(["companyLang", "defaultUTC", "defaultLang"]),
  },
  props: {
    curStep: { default: 1, type: Number, required: true },
    sync: { default: false, type: Boolean }, //同翻译，解决嵌套组件验证翻译无效问题
    items: { default: [], type: [Array, String], required: true },
    backgroundColor: { default: "mrc-grey", type: String },
    contentClass: { default: "white pa-8 mt-6", type: String }, //mt-6 bug1438 mel
  },
  watch: {
    defaultLang() {
      this.curkey = this.sync ? this.f_key : Math.random() * 100000000;
    },
  },
  data() {
    return {
      curkey: 1234,
      f_key: 1234,
    };
  },
};
</script>
